import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const ThreePeopleIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M11.9999 12.1772C13.7057 12.1772 15.0885 10.7944 15.0885 9.08859C15.0885 7.38281 13.7057 6 11.9999 6C10.2941 6 8.91133 7.38281 8.91133 9.08859C8.91133 10.7944 10.2941 12.1772 11.9999 12.1772ZM7.69976 10.29C7.69976 11.5221 6.70094 12.5209 5.46883 12.5209C4.23671 12.5209 3.23789 11.5221 3.23789 10.29C3.23789 9.05788 4.23671 8.05906 5.46883 8.05906C6.70094 8.05906 7.69976 9.05788 7.69976 10.29ZM20.7623 10.29C20.7623 11.5221 19.7634 12.5209 18.5313 12.5209C17.2992 12.5209 16.3004 11.5221 16.3004 10.29C16.3004 9.05788 17.2992 8.05906 18.5313 8.05906C19.7634 8.05906 20.7623 9.05788 20.7623 10.29ZM6.94688 14.7948C6.89761 14.8647 6.84948 14.9358 6.8025 15.008C6.15474 16.0075 5.81084 17.1736 5.8125 18.3647H18.1875C18.1887 17.1797 17.848 16.0195 17.2061 15.0234C17.1591 14.9512 17.111 14.8802 17.0617 14.8103C16.4903 14.0017 15.7331 13.342 14.8538 12.8866C13.9745 12.4313 12.9988 12.1937 12.0086 12.1937C11.0184 12.1937 10.0427 12.4313 9.16339 12.8866C8.2841 13.342 7.52692 14.0017 6.95547 14.8103L6.94688 14.7948ZM4.56469 16.9897H1C1.00014 16.278 1.17024 15.5767 1.49616 14.9441C1.82207 14.3114 2.29437 13.7658 2.87374 13.3525C3.45311 12.9392 4.12281 12.6703 4.82709 12.5681C5.53137 12.4659 6.24988 12.5334 6.92281 12.765C5.69535 13.877 4.8669 15.3612 4.56469 16.9897ZM17.0771 12.765C17.545 12.6037 18.0363 12.5212 18.5312 12.5209C19.7164 12.5209 20.853 12.9918 21.6911 13.8298C22.5291 14.6679 23 15.8045 23 16.9897H19.4353C19.1331 15.3612 18.3046 13.877 17.0771 12.765Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
